module.exports = __webpack_public_path__ + "media/images/flags/32/Curacao-4c7e2eaab480e80ebf88a6bb785df5bf.png";